<template>

		<user-table

			:organization-id="selectedOrganization.id"

			:archived-at="archivedAt"

			:selected.sync="selectedUser"

			:create.sync="create"

            @fetch="users => $emit('fetch', users)"

			ref="userTable"

		/>

</template>

<script>

import UserTable from "./userTable";

import UserForm from "./userForm";

export default {

	components: {

		UserTable, UserForm

	},

	props: [ 'selectedOrganization', 'createUser', 'person', 'archivedAt', 'keyword' ],

    data() {

        return {

            create: false,

            selectedUser: null

        }

    },

    watch: {

    	selectedUser(value) {

            this.$emit('update:person', value);

    	}

    },

    methods: {

    	refetch() {

            this.$refs.userTable.fetch();

    	},

        addUser(keyword) {

            this.$emit('update:createUser', true);

            this.$emit('update:person', null);

            this.$emit('update:keyword', keyword);

        },

    },

    computed: {

        canManageUsers() {

            return this.$store.getters["Auth/hasPermission"]("can manage users");

        },

    }


}

</script>



// WEBPACK FOOTER //
// src/components/pages/Organization/persons/index.vue